<template>
  <div :class="$style.container">
    <!-- TODO: @danealton переработать компонент поля ввода email -->
    <input-email
      ref="email"
      v-model="email"
      data-test="loginFormEmailInput"
      input-id="input-email"
      :input-name="$t('common.login')"
      :input-title="$t('indicate.electronic.mail')"
      :input-placeholder="$t('common.email')"
      :min-length="6"
      :disabled="loading"
    />

    <!-- TODO: @danealton переработать компонент поля ввода password -->
    <input-password
      ref="password"
      v-model="password"
      data-test="loginFormPasswordInput"
      input-id="input-password"
      :input-name="$t('common.password')"
      :input-title="$t('enter.password.minimum.six.symbols')"
      input-placeholder="••••••"
      :min-length="6"
      :disabled="loading"
    >
      <template v-slot:link>
        <a
          data-test="loginFormPasswordRestoreLink"
          class="restore-link"
          @click="$router.push({ name: 'restore.password' })"
        >
          {{ $t('common.remind') }}
        </a>
      </template>
    </input-password>

    <div :class="$style.submit">
      <!-- TODO: @danealton заменить на кнопку компонент -->
      <button
        data-test="loginFormSubmitButton"
        class="button special"
        :disabled="!isValid"
        @click="handleSubmit"
      >
        {{ $t('sign.in') }}
      </button>
    </div>
  </div>
</template>

<script>
import InputEmail from '@/components/inputElements/InputEmail';
import InputPassword from '@/components/inputElements/InputPassword';

export default {
  name: 'LoginForm',
  components: {
    InputEmail,
    InputPassword,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      email: '',
      password: '',
    };
  },
  computed: {
    isValid() {
      if (this.loading) {
        return false;
      }

      const isValidEmail = this.$validate.isNotEmptyString(this.email) && this.$refs.email && !this.$refs.email.$v.$error;

      const isValidPassword = this.$validate.isNotEmptyString(this.password) && this.$refs.password && !this.$refs.password.$v.$error;

      return isValidEmail && isValidPassword;
    },
  },
  methods: {
    handleSubmit() {
      if (!this.isValid) {
        this.$alert({
          type: 'warning',
          text: this.$t('mistakes.in.form'),
        });
        return;
      }

      this.$emit('submit', {
        username: this.email,
        password: this.password,
      });
    },
  },
};
</script>

<style lang="sass">
  .restore-link
    position: absolute !important
    right: 10px !important
    bottom: 14px !important
</style>

<style lang="sass" module>
  .submit
    margin-top: 20px

    +respond-to('medium')
      margin-top: 50px

    button
      +respond-to('medium')
        width: 225px
</style>
